// Tailwind CSS Style Sheet
import "assets/styles/index.css"
import { useContext, useEffect, useState } from "react"
import { Routes, Route, Navigate } from "react-router-dom"
import Login from "./components/pages/Login"
import Today from "./components/pages/Today"
import History from "./components/pages/History"
import Sidebar from "components/layout/Sidebar"
import Employees from "./components/pages/Employees"
import Worksites from "components/pages/Worksites"
import Contractors from "components/pages/Contractors/Contractors"
import ContractorEmployees from "components/pages/Contractors/ContractorEmployees"
import Suppliers from "components/pages/Suppliers/Suppliers"
import SupplierPersons from "components/pages/Suppliers/SupplierPersons"
import SupplierVehicles from "components/pages/Suppliers/SupplierVehicles"
import Users from "components/pages/Users"
import AuthContext from "context/AuthContext"

function App() {
  const authContext = useContext(AuthContext)

  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split(".")[1]))
    } catch (e) {
      return null
    }
  }

  const userIsLoggedIn = () => {
    if (!localStorage.getItem("token")) {
      return false
    }

    const decodedJwt = parseJwt(localStorage.getItem("token"))

    if (decodedJwt.exp * 1000 < Date.now()) {
      localStorage.clear()
      return false
    }

    return true
  }

  const isLoggedIn = userIsLoggedIn()

  useEffect(() => {}, [authContext.isLoggedIn])

  return (
    <>
      {isLoggedIn && (
        <>
          <Sidebar />
          <div className='text-4xl font-bold p-5 lg:ml-64'>
            <Routes>
              <Route path='/' element={<Navigate to={"/today"} />} />
              <Route path='/today' element={<Today />} />
              <Route path='/history' element={<History />} />
              <Route path='/employees' element={<Employees />} />
              <Route path='/suppliers' element={<Suppliers />} />
              <Route path='/suppliers/persons/:supplierId/*' element={<SupplierPersons />} />
              <Route path='/suppliers/vehicles/:supplierId/*' element={<SupplierVehicles />} />
              <Route path='/contractors' element={<Contractors />} exact />
              <Route
                path='/contractors/employees/:contractorId/*'
                element={<ContractorEmployees />}
              />
              <Route path='/worksites' element={<Worksites />} />
              <Route path='/users' element={<Users />} />
              <Route path='*' element={<Navigate to='/' />} />
            </Routes>
          </div>
        </>
      )}

      {!isLoggedIn && (
        <>
          <Routes>
            <Route path='/login' element={<Login />} />
            <Route path='*' element={<Navigate to='/login' />} />
          </Routes>
        </>
      )}
    </>
  )
}

export default App
